module.exports = __webpack_public_path__ + "img/2019qinglongxia-5.44e05a88.jpg";